// Date formatting utilities
// Extracted from EventPage.tsx for testability and reuse

const MONTH_ABBR = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const DAY_ABBR = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const DAY_FULL = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

export { MONTH_ABBR, DAY_ABBR, DAY_FULL };

export function formatShortDate(dateStr: string): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  return `${MONTH_ABBR[m - 1]} ${d}, ${String(y).slice(-2)}`;
}

export function formatEventDateTime(dateStr: string, timeStr?: string): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dayOfWeek = DAY_ABBR[new Date(y, m - 1, d).getDay()];
  let result = `${dayOfWeek} ${MONTH_ABBR[m - 1]} ${d}, ${y}`;
  if (timeStr) {
    const [h, min] = timeStr.split(':').map(Number);
    const ampm = h >= 12 ? 'PM' : 'AM';
    const hour12 = h % 12 || 12;
    result += ` @ ${hour12}:${String(min).padStart(2, '0')} ${ampm}`;
  }
  return result;
}

export function formatEventDateTimeParts(dateStr: string, timeStr?: string): { weekday: string; date: string; time?: string } {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dayOfWeek = DAY_ABBR[new Date(y, m - 1, d).getDay()];
  const datePart = `${MONTH_ABBR[m - 1]} ${d}, ${y}`;
  if (!timeStr) return { weekday: dayOfWeek, date: datePart };
  const [h, min] = timeStr.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;
  return { weekday: dayOfWeek, date: datePart, time: `@ ${hour12}:${String(min).padStart(2, '0')} ${ampm}` };
}

export function formatElapsed(isoString: string): string {
  const diffMs = Date.now() - new Date(isoString).getTime();
  const hours = Math.floor(diffMs / 3600000);
  if (hours >= 1) return `${hours}h`;
  const minutes = Math.floor(diffMs / 60000);
  if (minutes >= 1) return `${minutes}m`;
  return '<1m';
}

export function formatPrintDateTime(dateStr: string, startTimeStr?: string, endTimeStr?: string): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dayOfWeek = DAY_FULL[new Date(y, m - 1, d).getDay()];
  const datePart = `${String(m).padStart(2, '0')}/${String(d).padStart(2, '0')}/${y}`;

  let result = `${dayOfWeek} ${datePart}`;

  if (startTimeStr) {
    const formatTime = (t: string) => {
      const [h, min] = t.split(':').map(Number);
      const ampm = h >= 12 ? 'PM' : 'AM';
      const hour12 = h % 12 || 12;
      return `${hour12}:${String(min).padStart(2, '0')} ${ampm}`;
    };
    result += ` \u2022 ${formatTime(startTimeStr)}`;
    if (endTimeStr) {
      result += ` - ${formatTime(endTimeStr)}`;
    }
  }

  return result;
}
